module.exports = __webpack_public_path__ + "media/images/logo/gigbase+_logo-58b3fcdaf3aff879a70e39ec6a316f8b.svg";